<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    fill="none"
    stroke="currentColor"
    stroke-width="2.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="w-[36px] h-[36px] text-foregroundPrimary"
  >
    <line x1="5" y1="9" x2="31" y2="9" />
    <line x1="5" y1="18" x2="31" y2="18" />
    <line x1="5" y1="27" x2="31" y2="27" />
  </svg>
</template>

<script setup>
</script>